import React from 'react';
import styled, { keyframes, css } from 'styled-components';
import { motion } from 'framer-motion';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const SpinnerWrapper = styled(motion.div).withConfig({
  shouldForwardProp: (prop) => !['fullScreen', 'overlay'].includes(prop)
})`
  display: flex;
  align-items: center;
  justify-content: center;
  
  ${props => props.fullScreen && css`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(4px);
    z-index: var(--z-modal);
  `}
  
  ${props => props.overlay && css`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(2px);
    z-index: var(--z-modal);
  `}
`;

const SpinnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-md);
`;

const Spinner = styled.div`
  width: ${props => props.size || '32px'};
  height: ${props => props.size || '32px'};
  border: 2px solid var(--color-gray-200);
  border-top: 2px solid var(--color-primary);
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const LoadingText = styled.div`
  color: var(--color-text-secondary);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  text-align: center;
`;

const LoadingSpinner = ({
  size = '32px',
  text = 'Loading...',
  fullScreen = false,
  overlay = false,
  showText = true,
  ...props
}) => {
  return (
    <SpinnerWrapper
      fullScreen={fullScreen}
      overlay={overlay}
      initial={fullScreen ? { opacity: 0 } : {}}
      animate={fullScreen ? { opacity: 1 } : {}}
      exit={fullScreen ? { opacity: 0 } : {}}
      transition={{ duration: 0.2 }}
      {...props}
    >
      <SpinnerContainer>
        <Spinner size={size} />
        {showText && <LoadingText>{text}</LoadingText>}
      </SpinnerContainer>
    </SpinnerWrapper>
  );
};

export default LoadingSpinner; 